import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';

@Component({
    selector: 'pq-term-list',
    templateUrl: './term-list.component.html',
    styleUrls: ['./_term-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TermListComponent {
  @Output() usage: EventEmitter<object> = new EventEmitter<object>();

  public describedbyValue: string = 'termList_' + Math.random().toString(36).substr(2, 9);
  private _terms: object[] = [];

  @Input() public subcategoryLabel: string;
  @Input() public listTitle: string;

  @Input() set terms (data: object[]) {
    data.forEach((item: object) => {
      item['urlArray'] = item['url'].split('?')[0].split('/');
      item['queryObject'] = {};

      if (item['url'].split('?').length > 1) {
        const params = item['url'].split('?')[1].split('&');

        params.forEach((param: string) => {
          let paramData = param.split('=');
          item['queryObject'][paramData[0]] = paramData[1];
        });

      }

    });

    this._terms = data;
  };

  get terms(): object[] {
    return this._terms;
  }

  public ngOnChanges (changes: SimpleChanges) {
    if (changes.variable && changes.variable.currentValue) {
      // for debugging use only
      // console.log(changes.variable.currentValue);
    }
  }

  public trackUsage (name: string, linkData: object): void {
    this.usage.emit({ name: name, data: linkData });
  }
  public trackByFn(index, item) {
    return index;
  }
}
